module.exports = __webpack_public_path__ + "static/amazonsmilelogo-a67c398e65856596473d5e869c7871a7.png";